import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

const SEO = ({ title, description, keywords, image, url, type, jsonLd }) => {
    const siteTitle = 'Cplus Media LLC | Global Reklam, Yazılım & Dijital Pazarlama Ajansı';
    const defaultDescription = 'Cplus Media LLC; E-Ticaret (Amazon, Shopify, Etsy), Web & Mobil Yazılım, Yapay Zeka (AI) Otomasyonları, SEO ve Performans Pazarlama çözümleriyle markanızı global ölçekte büyütür.';
    const defaultKeywords = 'cplus media, reklam ajansı, dijital pazarlama ajansı, web yazılım, e-ticaret danışmanlığı, amazon danışmanlığı, shopify, etsy, yapay zeka otomasyon, n8n, seo, google ads, meta ads';
    const siteUrl = 'https://cplus.com.tr';
    const defaultImage = `${siteUrl}/og-image.png`;

    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/';
    const resolvedPath = url || currentPath;

    const metaTitle = title ? `${title} | Cplus Media LLC` : siteTitle;
    const metaDescription = description || defaultDescription;
    const metaKeywords = keywords || defaultKeywords;
    const metaImage = image ? (image.startsWith('http') ? image : `${siteUrl}${image}`) : defaultImage;
    const metaUrl = resolvedPath.startsWith('http') ? resolvedPath : `${siteUrl}${resolvedPath.startsWith('/') ? resolvedPath : `/${resolvedPath}`}`;

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta name="keywords" content={metaKeywords} />
            <link rel="canonical" href={metaUrl} />

            {/* Open Graph / WhatsApp / LinkedIn / Facebook */}
            <meta property="og:type" content={type || 'website'} />
            <meta property="og:url" content={metaUrl} />
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:image" content={metaImage} />
            <meta property="og:site_name" content="Cplus Media LLC" />
            <meta property="og:locale" content="tr_TR" />

            {/* Twitter / X */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:creator" content="@cplusmedia" />
            <meta name="twitter:url" content={metaUrl} />
            <meta name="twitter:title" content={metaTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={metaImage} />

            {/* Structured Data (JSON-LD) */}
            <script type="application/ld+json">
                {JSON.stringify(
                    jsonLd || {
                        '@context': 'https://schema.org',
                        '@type': 'Organization',
                        name: 'Cplus Media LLC',
                        url: siteUrl,
                        logo: `${siteUrl}/logo.png`,
                        image: defaultImage,
                        description: defaultDescription,
                        email: 'info@cplus.com.tr',
                        telephone: '+1-302-417-2720',
                        address: {
                            '@type': 'PostalAddress',
                            streetAddress: '520 Robinson LN, Unit 4C-15 4616',
                            addressLocality: 'Wilmington',
                            addressRegion: 'DE',
                            postalCode: '19805',
                            addressCountry: 'US',
                        },
                        sameAs: [
                            'https://www.facebook.com/cplusmedia',
                            'https://www.instagram.com/cplusmedia',
                            'https://www.linkedin.com/company/cplusmedia',
                        ],
                        contactPoint: {
                            '@type': 'ContactPoint',
                            telephone: '+1-302-417-2720',
                            email: 'info@cplus.com.tr',
                            contactType: 'customer service',
                            areaServed: ['TR', 'US', 'GB', 'EU'],
                            availableLanguage: ['Turkish', 'English'],
                        },
                    }
                )}
            </script>
        </Helmet>
    );
};

SEO.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    keywords: PropTypes.string,
    image: PropTypes.string,
    url: PropTypes.string,
    type: PropTypes.string,
    jsonLd: PropTypes.object,
};

export default SEO;
